import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TriggersPage } from '@/features/triggers';

export const Route = createFileRoute(
  '/workspaces/$workspaceId/integrations/triggers',
)({
  // `?create` opens the add form — the command palette's verb (spec 129).
  validateSearch: z.object({
    create: z.boolean().optional().catch(undefined),
  }),
  component: TriggersRoute,
});

export function TriggersRoute() {
  const { workspaceId } = Route.useParams();
  const { create } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <TriggersPage
      workspaceId={workspaceId}
      createRequested={create === true}
      onCreateDismissed={() => {
        void navigate({ search: {}, replace: true });
      }}
    />
  );
}
